module.exports = __webpack_public_path__ + "img/server_contact.bd6dad95.png";